import React from 'react';
import {connect} from 'react-redux'
import {toggleGlobalLoader} from "../../../store/calls/alertLoadingDispatch";
import {mountApplication, prepareApplicationFormFlow, pullApplication} from "../../../store/calls/applicationData";
import {getJsonFromUrl} from "../../../utils/parseUrl";
import api from "../../../store/api";
import _ from "lodash";
import Indicative from "./Indicative";
import formatters from "../../../utils/forms/formatters";
import KeyValPair from "../../theme/data/KeyValuePair";
import * as actions from "../../../store/actions"
import Logo from '../../theme/logo/logo';
import {getImprovementById, getProjectAmountFromProjectImprovements} from "../../../utils/projectDataUtils";
import PrintableHeader from '../../theme/printableHeader/printableHeader';

class ApplicationViewPrintable extends React.Component {


    constructor(props) {
        super(props);

        this.state ={
            loan_estimate_data: {},
            project_data: {},
            app_data: {},
            project_id: null,
            loan_estimate_id: null,
            app_id: null,
            sharingModal: true,
        }

    }


    componentDidMount() {
        toggleGlobalLoader(true);
        const app_id = this.props.match.params.id;
        let query_params = getJsonFromUrl(window.location.href);

        pullApplication(app_id)
            .catch((err) => {
                if (!err.response) {
                    this.setState({
                        error:
                            "There seems to have been a connectivity issue, we couldn't complete the build process with our server.",
                    });
                }

                if (_.get(err, "response.data.error")) {
                    this.setState({ error: _.get(err, "response.data.error") });
                } else {
                    this.setState({
                        error:
                            "Something went wrong.",
                    });
                }
            })
            .finally(() => {
                toggleGlobalLoader(false);
            });
    }


    buildKeyValBlock = (key, val) => {
        return <KeyValPair val={val} striped _key={key}/>
    }


    buildLoanCard = (loan) => {
        // {
        //     "amount": "100000",
        //     "balance": "500000",
        //     "loan_type": "cmbs",
        //     "holder_name": "Sunflower Bank",
        //     "term_expiry": "12/16/2050",
        //     "amortization": null,
        //     "contact_name": "John Smith",
        //     "contact_email": null,
        //     "contact_phone": null,
        //     "loan_seniority": "1",
        //     "annual_payment_amount": "10000"
        // }


        return (

            <div className={'card m-4'}>
                <div className={'card-header has-background-primary'}>
                    <div className={'card-header-title has-text-white'}>
                        <span className={'has-text-weight-semibold'}>{loan.holder_name}</span>
                    </div>
                </div>
                <div className={'card-body'}>
                    <div className={'card-content'}>

                        {this.buildKeyValBlock('Amount', formatters.USDCurrency.formatter(loan.amount))}

                        {this.buildKeyValBlock('Balance', formatters.USDCurrency.formatter(loan.balance))}

                        {this.buildKeyValBlock('Annual Payment Amount', formatters.USDCurrency.formatter(loan.annual_payment_amount))}

                        {this.buildKeyValBlock('Loan Type', loan.loan_type)}

                        {this.buildKeyValBlock('Seniority', formatters.loanSeniority.formatter(loan.loan_seniority))}

                        {this.buildKeyValBlock('Original Term of Loan', loan.original_term_of_loan)}

                        {this.buildKeyValBlock('Last Payment Schedule Date', loan.last_payment_schedule_date)}

                        {this.buildKeyValBlock('Contact Name', loan.contact_name)}

                        {this.buildKeyValBlock('Contact Phone', loan.contact_phone)}

                        {this.buildKeyValBlock('Contact Email', loan.contact_email)}

                    </div>
                </div>
            </div>

        )
    }

    buildNoDataCard = () => {

        return (
            <div className={'card m-4'}>
                <div className={'card-body'}>
                    <div className={'card-content'}>
                        <p className={'has-text-grey'}>There is no data for this section</p>
                    </div>
                </div>
            </div>
        )

    }

    buildApplicationReview = () => {

        let {appData, loanEstimateData, projectData} = this.props;
        return (
            <div className={'info-view-wrapper is-flex is-flex-direction-column'}>

                <div className={'is-flex'}>
                    <h3 className={'is-size-3 has-text-primary mx-5'}>The Applicant</h3>
                </div>

                <div className={'card m-4'}>

                    <div className={'card-body'}>
                        <div className={'card-header has-background-primary'}>
                            <div className={'card-header-title has-text-white'}>
                                <span className={'has-text-weight-semibold'}>{appData.name}</span>, {_.startCase(appData.role)}
                            </div>
                        </div>
                        <div className={'card-content print-fixe'}>
                            <div className={'block'}>
                                <p>{formatters.phone.formatter(appData.phone)}</p>
                                <p>{appData.email}</p>
                                <p>{appData.mailing_address}</p>
                            </div>
                            <div className={'block'}>
                                <p>{appData.company}</p>
                                {!!appData.is_contractor && appData.is_contractor !== 'false' &&
                                <p className={'has-text-weight-semibold'}>Contractor</p>}
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'is-flex mt-5 '}>
                    <h3 className={'is-size-3 has-text-primary mx-5'}>The Property</h3>
                </div>


                <div className={'card m-4'}>
                    <div className={'card-header has-background-primary'}>
                        <div className={'card-header-title has-text-white'}>
                            <span className={'has-text-weight-semibold'}>{projectData.address?.formatted_address}</span>
                        </div>
                    </div>
                    <div className={'card-body'}>
                        <div className={'card-content'}>
                            {!!appData.owner_name && appData.owner_name.length &&
                                this.buildKeyValBlock('Name of Owner', appData.owner_name)}

                            {this.buildKeyValBlock('Square Footage', appData.square_footage)}

                            {this.buildKeyValBlock('Estimated Value', formatters.USDCurrency.formatter(appData.est_market_value))}

                            {this.buildKeyValBlock('Last Appraised Value', formatters.USDCurrency.formatter(appData.appraisal))}

                            {this.buildKeyValBlock('Additional Property Info', appData.additional_property_info)}

                        </div>
                    </div>
                </div>


                <div className={'is-flex mt-5'}>
                    <h3 className={'is-size-3 has-text-primary mx-5'}>The Project</h3>
                </div>

                <div className={'card m-4'}>
                    <div className={'card-header has-background-primary'}>
                        <div className={'card-header-title has-text-white'}>
                            <span className={'has-text-weight-semibold'}>{projectData.project_name}:  {formatters.USDCurrency.formatter(
                                    getProjectAmountFromProjectImprovements(projectData?.improvements)
                                )} Requested
                            </span>
                        </div>
                    </div>
                    <div className={'card-body'}>
                        <div className={'card-content'}>
                            {this.buildKeyValBlock('Project Description', appData.project_description)}

                            {this.buildKeyValBlock('Improvements',
                                (projectData?.improvements || []).sort((a,b) => a.value < b.value ? 1 : -1)
                                    .map(d => {
                                        let imp = getImprovementById(d.id)
                                        return (
                                            <p>
                                            <span
                                                className={'has-text-weight-semibold'}> {imp.name},</span> {formatters.USDCurrency.formatter(d.value)}
                                            </p>
                                        )
                                    })
                            )}

                            {this.buildKeyValBlock('Start Date', formatters.date("iso", "LLLL d, yyyy").formatter(projectData.start_date))}

                        </div>
                    </div>
                </div>


                <div className={'is-flex mt-5'}>
                    <h3 className={'is-size-3 has-text-primary mx-5'}>Asset History</h3>
                </div>

                <div className={'card m-4'}>
                    <div className={'card-header has-background-primary'}>
                        <div className={'card-header-title has-text-white'}>
                            {this.getHistoryCardHeader()}
                        </div>
                    </div>
                    <div className={'card-body'}>

                        <div className={'card-content'}>
                            {this.buildKeyValBlock('Has there been a tax delinquency on the property since purchase? ',
                                formatters.yesNo.formatter(appData.prop_has_tax_delinquency))}

                            {this.buildKeyValBlock('Has there been a payment default on the mortgage in the last three years?',
                                formatters.yesNo.formatter(appData.prop_has_mortgage_default))}

                            {this.buildKeyValBlock('Is the parcel currently listed as an asset in bankruptcy? ',
                                formatters.yesNo.formatter(appData.prop_is_bankruptcy_asset))}

                            {this.buildKeyValBlock('Has the owner declared bankruptcy in the last five years?',
                                formatters.yesNo.formatter(appData.prop_has_involuntary_liens))}

                            {this.buildKeyValBlock('Are there any involuntary liens recorded on the property? ',
                                formatters.yesNo.formatter(appData.owner_has_declared_bankruptcy))}

                            {this.buildKeyValBlock('Is there an SBA lien recorded on the property? ',
                                formatters.yesNo.formatter(appData.prop_has_sba_lien))}

                            {this.buildKeyValBlock('Explanation to any "yes" answers above',
                                appData.prop_history_explanation)}

                        </div>
                    </div>
                </div>


                <div className={'is-flex mt-5'}>
                    <h3 className={'is-size-3 has-text-primary mx-5'}>Existing Liens on the Property</h3>
                </div>

                {(appData?.loans || []).length ?

                    appData.loans.sort((a,b) => a.loan_seniority < b.loan_seniority ? -1 : 1)
                        .map(d => this.buildLoanCard(d))

                    : this.buildNoDataCard()
                }
            </div>
        )
    }


    getHistoryCardHeader = () => {
        // make sure that they are all no. If yes, remind that they need an explanation.
        let {appData} = this.props;
        let fields = [
            appData.prop_has_tax_delinquency,
            appData.prop_has_mortgage_default,
            appData.prop_is_bankruptcy_asset,
            appData.prop_has_involuntary_liens,
            appData.owner_has_declared_bankruptcy,
            appData.prop_has_sba_lien
        ]

        if (fields.every(d => !d || _.lowerCase(d) === "false")) {
            return "No issues to report"
        } else {
            return "Some issues may require additional underwriting"
        }
    }

    renderAssets = () => {
                // eslint-disable-next-line no-lone-blocks
                
                         
    }
    render() {
        let {appData, loanEstimateData, projectData} = this.props;
         return (
            <div className="print-page printable-wrapper aplication-printable">
                    <PrintableHeader projectName={projectData.project_name} projectAmount={formatters.USDCurrency.formatter(
                                            getProjectAmountFromProjectImprovements(projectData?.improvements)
                                        )}/>
                    {this.buildApplicationReview()}
            </div>
         )
    }

}
const mapStateToProps = state => ({
    appData: state.applicationData.app,
    loanEstimateData: state.applicationData.indicative,
    projectData: state.applicationData.projectLead,
    files: state.applicationData.files
})

const mapDispatchToProps = dispatch => ({
    setCurrStep: data => dispatch(actions.formFlow.setFormFlowCurrStep(data)),
})


export default connect(mapStateToProps, mapDispatchToProps)(ApplicationViewPrintable)


